//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { InputLabel, MenuItem } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { ContrastFormControl, ContrastSelect } from '@/components/Elements/Contrast';
import { useConfig } from '@/hooks/useConfig';
import { useLLM } from '@/hooks/useLLM';

interface LLMSelectorProps {
  sx?: SxProps<Theme>;
}

const LLMSelector = ({ sx = {} }: LLMSelectorProps) => {
  const { appConfig } = useConfig();
  const { activeLLM, setActiveLLM } = useLLM();

  const llmConfig = appConfig?.llm_config || {};
  const llmChoices = Object.entries(llmConfig).sort((a, b) => {
    const nameA = a[1].display_name ?? a[0];
    const nameB = b[1].display_name ?? b[0];
    return nameA.localeCompare(nameB);
  });

  return llmChoices.length > 1 && (
    <ContrastFormControl size="small" sx={[
      { verticalAlign: 'middle', minWidth: 150 },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}>
      <InputLabel id="large-language-model-label" disableAnimation>AI Model</InputLabel>
      <ContrastSelect
        labelId="large-language-model-label"
        id="large-language-model-select"
        value={activeLLM || ''}
        label="AI Model"
        size="small"
        onChange={(e) => {
          setActiveLLM(e.target.value);
        }}
      >
        {llmChoices.map(([llm, config]) => (
          <MenuItem key={llm} value={llm}>{config.display_name ?? llm}</MenuItem>
        ))}
      </ContrastSelect>
    </ContrastFormControl>
  );
};

export default LLMSelector;
